import { Service } from '@/api/http-service';
import type { GetBrevoContactBlacklistedResponseDto } from '@carvia/ros-client-types';

class NewsletterService extends Service {
  async setContactBlacklisted(email: string, blacklisted: boolean): Promise<void> {
    await this.httpClient.post(`${this.endpoint}/brevo-contact-to-blacklisted`, {
      email,
      blacklisted,
    });
  }

  async getContactBlacklisted(email: string): Promise<GetBrevoContactBlacklistedResponseDto> {
    const response = await this.httpClient.get<GetBrevoContactBlacklistedResponseDto>(
      `${this.endpoint}/brevo-contact-blacklisted`,
      {
        params: { email },
      },
    );
    return response.data;
  }
}

export const newsletterService = new NewsletterService('/newsletter');
